import React from 'react';
import VideoGallery from '../VideoGallery';

export default function Videos() {
  return <VideoGallery canDelete={true} canSelect={false} />;
}